import type { RevenueShareStatementRow } from '../../../types/revenueShare';
import { centsToDollars } from '../../utils/useStatementModel';
import { formatDateDisplay } from '../../../utils/date';

import { METHOD_LABELS } from './methodLabels';

/**
 * Payment-level audit trail behind a program row — the detail that makes the
 * statement number defensible.
 */
export function DrilldownRows({ rows }: { rows: RevenueShareStatementRow[] }) {
  return (
    <tr>
      <td />
      <td colSpan={5} className="px-2 pb-3 pt-0">
        <table className="w-full text-xs">
          <tbody>
            {rows.map((r, i) => (
              <tr
                key={`${r.payment_id}-${r.kind}-${i}`}
                className={`border-t border-gray-100 ${r.kind === 'refund' ? 'text-red-700' : 'text-gray-500'}`}
              >
                <td className="py-1 pr-3 tabular-nums">{formatDateDisplay(r.payment_date)}</td>
                <td className="py-1 pr-3 font-medium text-gray-600">{r.student_name ?? '—'}</td>
                <td className="py-1 pr-3">{r.parent_name ?? '—'}</td>
                <td className="py-1 pr-3">
                  {METHOD_LABELS[r.payment_method] ?? r.payment_method}
                  {r.kind === 'refund' && ' · refund'}
                </td>
                <td className="py-1 pr-3 text-right tabular-nums">
                  ${centsToDollars(r.tuition_cents)}
                  {r.discount_cents !== 0 && (
                    <span className="text-gray-400">
                      {' '}
                      (after −${centsToDollars(Math.abs(r.discount_cents))} discount)
                    </span>
                  )}
                  {r.bonus_excluded_cents !== 0 && (
                    <span className="text-amber-700"> (bonus −${centsToDollars(r.bonus_excluded_cents)})</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </td>
    </tr>
  );
}
